import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class PreferencesUpdateBehaviour extends AbstractDataAttributeBehaviour {
  attrNames = {
    'container': 'data-preferences-update',
    'description': 'data-preference-description',
    'type': 'data-preference-type',
    'eventType': 'data-event-type'
  };

  getContainerSelector = () => '[' + this.attrNames.container + ']';
  getEventTypeSelector = () => '[' + this.attrNames.eventType + ']';

  getEventType = () => document.querySelector(this.getEventTypeSelector()).getAttribute(this.attrNames.eventType);

  hasPreferenceCategoryUpdated = (category, originalPreferences, preferences) => {
    return (originalPreferences[category].length !== preferences[category].length);
  }

  dispatchEvent = (preferences, originalPreferences) => {
    window.dataLayer.push({
      event: 'preferences_completed',
      type: this.getEventType(),
      selectedPreferences: preferences,
      cruiseLines: preferences.CruiseLines,
      cruiseTypes: preferences.CruiseTypes,
      cruiseRegions: preferences.CruiseRegions
    });

    if (this.hasPreferenceCategoryUpdated('CruiseLines', originalPreferences, preferences)) window.dataLayer.push({ event: `preferences_completed_cruiselines` });
    if (this.hasPreferenceCategoryUpdated('CruiseTypes', originalPreferences, preferences)) window.dataLayer.push({ event: `preferences_completed_cruisetypes` });
    if (this.hasPreferenceCategoryUpdated('CruiseRegions', originalPreferences, preferences)) window.dataLayer.push({ event: `preferences_completed_cruiseregions` });
  }

  dispatchPreference = (category, preference) => {
    window.dataLayer.push({
      event: `preferences_updated_${category}`,
      label: category,
      action: preference
    });
  }

  dispatchIndividualPreferences = (preferences, originalPreferences) => {
    Object.keys(preferences).map(category => {
      if (preferences[category].length > 0 && this.hasPreferenceCategoryUpdated(category, preferences, originalPreferences)) {
        preferences[category].map(pref => this.dispatchPreference(category, pref));
      }
    });
  }

  getSelectedPreferenceInputs = container => {
    let formId = null;
    if(container.tagName.toLowerCase() === 'form') {
      formId = container.getAttribute('id');
    } else {
      formId = container.closest('form').getAttribute('id');
    }

    if(!formId) return [];

    return [
        ...container.querySelectorAll(`#${formId}_CruiseLines input[type="checkbox"]:checked`),
        ...container.querySelectorAll(`#${formId}_CruiseTypes input[type="checkbox"]:checked`),
        ...container.querySelectorAll(`#${formId}_CruiseRegions input[type="checkbox"]:checked`)
    ];
  }

  buildPreferencesObject = () => {
    return {
      'CruiseLines': [],
      'CruiseTypes': [],
      'CruiseRegions': [],
    }
  }

  assignPreferenceValues = (selectedPrefInputs, object) => {
    selectedPrefInputs.map(input => {
      const type = input.getAttribute(this.attrNames.type);
      const description = input.getAttribute(this.attrNames.description);

      object[type].push(description);
    });

    return object;
  }

  initContainer = (container) => {
    let originalPreferences = this.buildPreferencesObject();
    const selectedPrefInputs = this.getSelectedPreferenceInputs(container);

    originalPreferences = this.assignPreferenceValues(
      selectedPrefInputs,
      this.buildPreferencesObject()
    );

    let form = window.app.formManager.getForm(container.getAttribute('id'));
    form.registerHook('postSubmit',  (form) => {
        const selectedPrefInputs = this.getSelectedPreferenceInputs(form.form);
        const preferencesObject = this.assignPreferenceValues(
            selectedPrefInputs,
            this.buildPreferencesObject()
        );

        if(form.formValidator.validationState == form.formValidator.STATUS_VALID) {
          this.dispatchIndividualPreferences(preferencesObject, originalPreferences);
          this.dispatchEvent(preferencesObject, originalPreferences);
        }
    });
  }
}